import {
    ConnectionType,
    Conversation,
    WebRTCConnection,
    WebSocketConnection,
} from '@elevenlabs/client';
import { Nullable } from '../types';
import { ResponseMessage } from './types';
import { escapeHTML } from '../../shared/utils/sanitize';

let conversation: Nullable<Conversation>;
let ws: WebSocketConnection;
let connectionType: ConnectionType;
let rtc: WebRTCConnection;
/**
 * @description start conversation with eleven labs agent
 * @param agent_id agent id to identify connection
 * @param status html element to display connection status
 */
async function startConversation(
  stream: MediaStream,
  agent_id: string,
  status: HTMLParagraphElement,
  messagesContainer: HTMLDivElement,
  micButton:HTMLButtonElement
): Promise<Nullable<MediaStream>> {
  try {
    if (!conversation) {
      // Ensure we have microphone access

      let messages: ResponseMessage[] = [];

      // Launch the WebSocket session with your agent
      conversation = await Conversation.startSession({
        agentId: agent_id, // pass your agent ID here

        onConnect: () => {
          status.textContent = 'Connected';
          micButton.disabled = true;
          // stopButton.disabled = false;
        },
        onDisconnect: () => {
          status.textContent = 'Disconnected';
          micButton.disabled=false;
          // startButton.disabled = false;
          // stopButton.disabled = true;
        },
        onError: (err: any) => {
          console.error('Conversation error:', err);
          micButton.disabled=false;
        },
        onMessage(props) {
          messages.push(props);

          const documentFragment = document.createDocumentFragment();

          messages.forEach((message) => {
            const paragraph = document.createElement('p');
            // Escape HTML to prevent XSS attacks
            const safeSource = escapeHTML(message.source);
            const safeMessage = escapeHTML(message.message);
            paragraph.innerHTML = `
                        <strong>${safeSource}</strong> : ${safeMessage}
                    `;
            documentFragment.appendChild(paragraph);
          });

          messagesContainer.innerHTML = ``;
          messagesContainer.appendChild(documentFragment);
          messagesContainer.scrollTop = messagesContainer.scrollHeight;
        },

        //@ts-ignore
        onModeChange: ({ mode }) => {
          // mode is 'listening' or 'speaking'
          status.textContent = mode as string;
          if(status.textContent==="listening"){
            micButton.disabled=false;
          }
        },
      });

      conversation.sendUserMessage('');

      return stream;
    }
    return null;
  } catch (err) {
    console.error('Failed to start conversation:', err);
    return null;
  }
}

function sendTextToVoiceAgent(input: HTMLInputElement) {
  if (input.value.trim() !== '') {
    if (conversation) conversation.sendUserMessage(input.value.trim());
    input.value = '';
  }
}

/**
 * @description stop the conversation
 */
async function stopConversation(): Promise<void> {
  if (conversation) {
    await conversation.endSession();
    conversation = null;
  }
}

export { sendTextToVoiceAgent, startConversation, stopConversation };

